import ILSNotFoundPage from '@components/custom/404';
import { FC } from 'react';

const NotFoundPage: FC = () => {
  return <ILSNotFoundPage />;
};

export default NotFoundPage;
